import { useLayoutEffect, useRef } from "react";

// Check the fixed Production layout without adding notes or changing its spacing.
export function validateTicketContent(card: HTMLElement) {
  const details = card.querySelector<HTMLElement>(".info-section");
  const types = card.querySelector<HTMLElement>(".types-section");
  const footer = card.querySelector<HTMLElement>(".footer-section");
  if (!details || !types || !footer) return;
  delete card.dataset.ticketOverflow;
  if (details.getBoundingClientRect().bottom > types.getBoundingClientRect().top + 1 ||
      types.getBoundingClientRect().bottom > footer.getBoundingClientRect().top + 1) {
    card.dataset.ticketOverflow = "unresolved";
  }
}

export default function useTicketContentCheck() {
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const card = ref.current;
    if (!card) return;
    let active = true;
    const check = () => { if (active) validateTicketContent(card); };
    check();
    const images = Array.from(card.querySelectorAll("img"));
    images.forEach(image => image.addEventListener("load", check));
    document.fonts?.ready.then(check);
    return () => {
      active = false;
      images.forEach(image => image.removeEventListener("load", check));
    };
  });
  return ref;
}
